import React from 'react';
import {toPriceStr} from '@/utils';
import {TeamReportListContent} from '@/common-pages/proxy/proxy.type';
import {TeamBodyTitle} from '../teams/team-table-body';

interface TableCellProps {
  item: TeamReportListContent;
  onUserClick: (userId: number) => void;
}

// 用户ID单元格
export const UserIdCell = ({
  item,
  onUserClick,
}: TableCellProps): TeamBodyTitle => {
  return {
    className: 'w-[7.5rem] justify-center',
    text: (
      <div
        onClick={() => onUserClick(item.userId)}
        className="text-blue-600 flex flex-row items-center gap-x-1 cursor-pointer">
        <span>{item.userId}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-3 h-3"
          viewBox="0 0 12 12"
          fill="none">
          <path
            d="M7.82313 5.34417C8.21781 5.68598 8.21781 6.29825 7.82313 6.64005L4.84672 9.2177C4.2916 9.69845 3.42845 9.30412 3.42845 8.56976L3.42845 3.41447C3.42845 2.68011 4.2916 2.28578 4.84672 2.76653L7.82313 5.34417Z"
            fill="currentColor"
          />
        </svg>
      </div>
    ),
  };
};

// 用户数量单元格
export const UserCountCell = ({item}: TableCellProps): TeamBodyTitle => {
  return {
    className: 'w-14 px-3',
    text: item.userCount,
  };
};

// 充值金额单元格
export const RechargeAmountCell = ({item}: TableCellProps): TeamBodyTitle => {
  return {
    className: 'w-[6rem] justify-center',
    text: toPriceStr(+item.rechargeAmount),
  };
};

// 投注金额单元格
export const BetAmountCell = ({item}: TableCellProps): TeamBodyTitle => {
  return {
    className: 'w-[6rem] justify-center',
    text: toPriceStr(+item.betAmount),
  };
};

// 佣金金额单元格
export const CommissionAmountCell = ({item}: TableCellProps): TeamBodyTitle => {
  return {
    className: 'w-[6rem] justify-center',
    text: toPriceStr(+item.commissionAmount),
  };
};

// 创建表格单元格配置的函数
export const createTableCells = (onUserClick: (userId: number) => void) => {
  return [
    (item: unknown) => {
      const _item = item as TeamReportListContent;
      return UserIdCell({item: _item, onUserClick});
    },
    (item: unknown) => {
      const _item = item as TeamReportListContent;
      return UserCountCell({item: _item, onUserClick: () => {}});
    },
    (item: unknown) => {
      const _item = item as TeamReportListContent;
      return RechargeAmountCell({item: _item, onUserClick: () => {}});
    },
    (item: unknown) => {
      const _item = item as TeamReportListContent;
      return BetAmountCell({item: _item, onUserClick: () => {}});
    },
    (item: unknown) => {
      const _item = item as TeamReportListContent;
      return CommissionAmountCell({item: _item, onUserClick: () => {}});
    },
  ];
};
